export default "__VITE_ASSET__BQfZ1b0I__"